<template>
  <div class="menuBody">
    <CommonUserProjectTree @AllData="getMsgFormSon" />
    <PropertyDialog
      :param="diaLogData"
      @Visible="Visible"
      ref="PropertyDialog"
    />
    <div class="menuTool" style="width: 100%">
      <el-card class="box-card">
        <el-row :gutter="10">
          <div
            style="
              border-bottom: 1px solid rgba(234, 237, 241, 1);
              width: 100%;
              height: 30px;
              margin-bottom: 10px;
            "
          >
            项目列表
          </div>
          <div style="width: 170px; float: left">
            <el-select
              clearable
              v-model="value"
              placeholder="请选择物业类型"
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div style="width: 170px; float: left; margin-left: 30px">
            <el-input
              placeholder="请输入项目代码"
              size="small"
              v-model="ItemCode"
            ></el-input>
          </div>
          <div style="width: 170px; float: left; margin-left: 30px">
            <el-input
              placeholder="请输入项目名称"
              size="small"
              v-model="ItemName"
            ></el-input>
          </div>
          <div
            style="float: left; margin-left: 30px"
            v-Jurisdiction="'wy:web:pm:project:list'"
          >
            <el-button
              type="primary"
              size="small"
              plain
              style="background: #246ce5; color: #fff; border-radius: 9px"
              @click="Inquire()"
              >查询</el-button
            >
          </div>
          <div style="float: right" v-Jurisdiction="'wy:web:pm:project:add'">
            <el-button
              type="primary"
              size="small"
              plain
              style="background: #38a38a; color: #fff; border-radius: 9px"
              @click="PropertyAdd()"
              >添加项目</el-button
            >
          </div>
          <el-table
            :data="tableData"
            tooltip-effect="light"
            v-loading="loading"
            @selection-change="handleSelectionChange"
            style="margin-top: 30px; overflow-y: scroll; float: right"
            row-key="id"
            border
            :default-expand-all="false"
            :stripe="true"
            :tree-props="{ children: 'children' }"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="remarks"
              label="归属机构"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="orgCode"
              label="物业类型"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.orgCode == '1'">住宅小区</el-tag>
                <el-tag v-if="scope.row.orgCode == '2'">办公楼</el-tag>
                <!-- <el-tag v-if="scope.row.orgCode=='3'" >商品房</el-tag>
        <el-tag v-if="scope.row.orgCode=='4'" >空房</el-tag>
        <el-tag v-if="scope.row.orgCode=='5'" >售后公房</el-tag>
        <el-tag v-if="scope.row.orgCode=='6'" >售后公房（商）</el-tag>
        <el-tag v-if="scope.row.orgCode=='7'" >联排别墅</el-tag>
        <el-tag v-if="scope.row.orgCode=='8'" >复式</el-tag>
        <el-tag v-if="scope.row.orgCode=='9'" >联排</el-tag>
        <el-tag v-if="scope.row.orgCode=='10'" >公寓</el-tag>
        <el-tag v-if="scope.row.orgCode=='11'" >独栋</el-tag>
        <el-tag v-if="scope.row.orgCode=='12'" >双拼</el-tag>
        <el-tag v-if="scope.row.orgCode=='13'" >多层住宅</el-tag>
        <el-tag v-if="scope.row.orgCode=='14'" >高层住宅</el-tag>
        <el-tag v-if="scope.row.orgCode=='15'" >商业用房</el-tag>
        <el-tag v-if="scope.row.orgCode=='16'" >办公用房</el-tag>
        <el-tag v-if="scope.row.orgCode=='17'" >别墅</el-tag>
        <el-tag v-if="scope.row.orgCode=='18'" >商铺</el-tag>
        <el-tag v-if="scope.row.orgCode=='19'" >写字楼</el-tag> -->
                <!-- <el-tag v-if="scope.row.orgCode== null " >其他</el-tag> -->
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="code"
              label="项目代码"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="name"
              label="项目名称"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="buildArea"
              label="建筑面积"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="finishDate"
              label="竣工日期"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="remarks"
              label="备注信息"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="updateDate"
              label="更新时间"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="120px">
              <template slot-scope="scope">
                <el-button
                  @click="editMenu(scope.row)"
                  type="primary"
                  icon="el-icon-edit"
                  v-Jurisdiction="'wy:web:pm:project:edit'"
                  circle
                  size="small"
                  title="修改"
                ></el-button>
                <el-button
                  @click="delMenu(scope.row)"
                  type="danger"
                  icon="el-icon-delete"
                  v-Jurisdiction="'wy:web:pm:project:del'"
                  circle
                  size="small"
                  title="删除"
                  v-debounce
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="float: right; margin-top: 25px"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import PropertyDialog from "../common/PropertyDialog";
import CommonUserProjectTree from "../common/CommonUserProjectTree";
export default {
  name: "ProjectManagement",
  components: { PropertyDialog, CommonUserProjectTree },
  data() {
    return {
      loading: false,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      ItemName: "",
      ItemCode: "",
      Code: "",
      Name: "",
      tableData: [],
      options: [
        { valueone: "1", labelone: "住宅小区" },
        { valueone: "2", labelone: "办公楼" },
      ],
      value: "",
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: "",
        paramObj: {},
        paramList: [],
      },
      AllData: "",
      USERList: "",
      orgId: "",
    };
  },
  methods: {
    Visible(data) {
      if (data == false) {
        this.getAllMenu();
      }
    },
    handleSelectionChange(val) {},
    getMsgFormSon(data) {
      this.loading = true;
      this.orgId = data.officeId;
      this.Name = data.officeName;
      this.AllData = data;
      this.getAllMenu();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getAllMenu();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAllMenu();
    },
    getAllMenu() {
      let PageSize = {
        page: this.currentPage, // 当前页
        size: this.pagesize, // 每页大小
        code: this.ItemCode,
        name: this.ItemName,
        orgId: this.orgId,
      };
      this.$http
        .post(this.$requestUrl.POST_PROJECT_LIST, PageSize)
        .then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total;
            this.tableData = data.data.records;
            this.loading = false;
          } else {
            this.$message.error(result.msg);
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR);
        });
    },
    Inquire() {
      let PageSize = {
        orgCode: this.value,
        page: this.currentPage, // 当前页
        size: this.pagesize, // 每页大小
        code: this.ItemCode,
        name: this.ItemName,
        orgId: this.orgId,
      };
      this.$http
        .post(this.$requestUrl.POST_PROJECT_LIST, PageSize)
        .then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total;
            this.tableData = data.data.records;
            for (let val of data.data.records) {
              let time = val.updateDate;
              let timeD = time.replace("T", "-");
              let TimeData = timeD.slice(0, 19);
              val.TimeData = TimeData;
            }
          } else {
            this.$message.error(result.msg);
          }
        })
        .catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR);
        });
    },

    PropertyAdd() {
      // 添加项目
      this.$refs.PropertyDialog.title = "添加";
      this.$refs.PropertyDialog.dialogVisible = true;
      this.$refs.PropertyDialog.type = "项目";
      let obj = {
        areaname: "归属机构",
        orgCode: "物业类型",
        code: "项目代码",
        name: "项目名称",
        site: "地址",
        floor: "占地面积",
        buildArea: "建筑面积",
        public: "公共场所面积",
        afforest: "绿化面积",
        way: "道路面积",
        groundarea: "地上停车面积",
        undergroundarea: "地下停车面积",
        groundCar: "地上车位数",
        undergroundCar: "地下车位数",
        start: "开工日期",
        finishDate: "竣工日期",
        design: "设计单位",
        exploit: "开发单位",
        remarks: "备注信息",
      };
      let row = {};
      row.obj = obj;
      this.$refs.PropertyDialog.formLabelAlign = row;
    },
    editMenu(row) {
      // 修改
      this.$refs.PropertyDialog.title = "修改";
      this.$refs.PropertyDialog.dialogVisible = true;
      this.$refs.PropertyDialog.type = "项目";
      let obj = {
        areaname: "归属机构",
        orgCode: "物业类型",
        code: "项目代码",
        name: "项目名称",
        site: "地址",
        floor: "占地面积",
        buildArea: "建筑面积",
        public: "公共场所面积",
        afforest: "绿化面积",
        way: "道路面积",
        groundarea: "地上停车面积",
        undergroundarea: "地下停车面积",
        groundCar: "地上车位数",
        undergroundCar: "地下车位数",
        start: "开工日期",
        finishDate: "竣工日期",
        design: "设计单位",
        exploit: "开发单位",
        remarks: "备注信息",
      };
      row.obj = obj;
      this.$refs.PropertyDialog.value = row.remarks;
      this.$refs.PropertyDialog.valueone = row.orgCode;
      this.$refs.PropertyDialog.formLabelAlign = row;
    },
    delMenu(row) {
      this.$confirm("是否确认要删除该项目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete(this.$requestUrl.DELETE_PROJECT + row.id)
            .then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.getAllMenu();
              }
            })
            .catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR);
            });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    // this.getAllMenu();
  },
};
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }
}
</style>